import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import React, { useState } from "react";
import { Button, ButtonSize, ButtonVariant, Text, TextColor, TextSize, TextWeight } from "../../components";
import { isGlsPoint, isInPostPoint } from "../../types/deliveryPoints.type";
import { formatGroupedHours, isOpenNow } from "../../utils/timeFormatter";
import { GLSMap, InPostMap } from "./components";
// Logos
import BlikIcon from "./logos/blik.png";
import PaynowIcon from "./logos/paynow.png";
import TransferIcon from "./logos/visa.png";
import WalletIcon from "./logos/wallet.png";

// Komponenty dla wyświetlania wybranego punktu dostawy
const DeliveryPointDisplay = t0 => {
  const $ = _c(13);
  const {
    deliveryPoint,
    onChangePoint
  } = t0;
  if (!deliveryPoint) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text text="Wybrany punkt dostawy" fontSize={TextSize.XS} color={TextColor.BLUE} weight={TextWeight.MEDIUM} className="mb-2" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== deliveryPoint) {
    t2 = isInPostPoint(deliveryPoint) && <div><Text text={deliveryPoint.name} fontSize={TextSize.S} weight={TextWeight.BOLD} className="mb-1" /><Text text={`${deliveryPoint.address.line1}, ${deliveryPoint.address.line2}`} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_600} className="mb-1" /><Text text={`Godziny: ${deliveryPoint.openingHours}`} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_600} /></div>;
    $[1] = deliveryPoint;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== deliveryPoint) {
    t3 = isGlsPoint(deliveryPoint) && <div><div className="flex items-center gap-2 mb-1"><Text text={deliveryPoint.name} fontSize={TextSize.S} weight={TextWeight.BOLD} />{isOpenNow(deliveryPoint.openHours) && <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full">Otwarte</span>}</div><Text text={`${deliveryPoint.street}, ${deliveryPoint.postalCode} ${deliveryPoint.city}`} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_600} className="mb-1" /><Text text={formatGroupedHours(deliveryPoint.openHours)} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_600} /></div>;
    $[3] = deliveryPoint;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex-1">{t1}{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onChangePoint) {
    t5 = <Button text={"Zmie\u0144"} variant={ButtonVariant.SECONDARY} size={ButtonSize.XS} onClick={onChangePoint} className="ml-4" />;
    $[8] = onChangePoint;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="p-4 bg-blue-50 border-t border-blue-200"><div className="flex justify-between items-start">{t4}{t5}</div></div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};

// Funkcja do przypisywania ikon na podstawie typu płatności
const getPaymentIcon = option => {
  const text = option.callToActionText.toLowerCase();
  if (text.includes("blik")) {
    return BlikIcon;
  } else if (text.includes("szybkim przelewem") || text.includes("przelewem")) {
    return PaynowIcon;
  } else if (text.includes("kartą") || text.includes("visa") || text.includes("mastercard")) {
    return TransferIcon;
  } else if (text.includes("portfelem") || text.includes("apple pay") || text.includes("google pay")) {
    return WalletIcon;
  } else if (text.includes("gotówką") || text.includes("odbiorze")) {
    return null;
  }

  // Domyślna ikona
  return null;
};
export const ShippingOption = t0 => {
  const $ = _c(62);
  const {
    option,
    selectedOption,
    setSelectedOption,
    selectedDeliveryPoint,
    onDeliveryPointSelected,
    requiresDeliveryPointByName
  } = t0;
  const [isInPostMapVisible, setIsInPostMapVisible] = useState(false);
  const [isGLSMapVisible, setIsGLSMapVisible] = useState(false);
  const isSelected = Number(selectedOption) === option.id;
  let t1;
  if ($[0] !== option.name || $[1] !== requiresDeliveryPointByName) {
    t1 = requiresDeliveryPointByName(option.name);
    $[0] = option.name;
    $[1] = requiresDeliveryPointByName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const needsDeliveryPoint = t1;
  const hasSelectedPoint = selectedDeliveryPoint !== null;
  let t2;
  if ($[3] !== onDeliveryPointSelected || $[4] !== option.id || $[5] !== option.name || $[6] !== setSelectedOption) {
    t2 = () => {
      setSelectedOption(option.id.toString());
      if (option.name === "InPost Paczkomat 24/7 dostawa D+1") {
        setIsInPostMapVisible(true);
      } else {
        if (option.name === "Odbi\xF3r w punkcie GLS") {
          setIsGLSMapVisible(true);
        } else {
          onDeliveryPointSelected(null);
        }
      }
    };
    $[3] = onDeliveryPointSelected;
    $[4] = option.id;
    $[5] = option.name;
    $[6] = setSelectedOption;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleOptionSelect = t2;
  let t3;
  if ($[8] !== option.name) {
    t3 = () => {
      if (option.name === "InPost Paczkomat 24/7 dostawa D+1") {
        setIsInPostMapVisible(true);
      } else {
        if (option.name === "Odbi\xF3r w punkcie GLS") {
          setIsGLSMapVisible(true);
        }
      }
    };
    $[8] = option.name;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleChangePoint = t3;
  let t4;
  if ($[10] !== handleOptionSelect || $[11] !== isSelected || $[12] !== option.id) {
    t4 = <input type="radio" name="shipping" value={option.id} checked={isSelected} onChange={handleOptionSelect} className="w-4 h-4 accent-black border-gray-300 focus:ring-black" />;
    $[10] = handleOptionSelect;
    $[11] = isSelected;
    $[12] = option.id;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== option.name) {
    t5 = <Text text={option.name} weight={TextWeight.BOLD} fontSize={TextSize.S} />;
    $[14] = option.name;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== option.delay) {
    t6 = <Text text={option.delay} color={TextColor.GRAYSCALE_500} fontSize={TextSize.XS} />;
    $[16] = option.delay;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t4 || $[22] !== t7) {
    t8 = <div className="flex items-center space-x-4">{t4}{t7}</div>;
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== option.price) {
    t9 = <Text text={option.price} color={TextColor.GRAYSCALE_900} fontSize={TextSize.S} className="min-w-[90px] text-right" />;
    $[24] = option.price;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t8 || $[27] !== t9) {
    t10 = <label className="flex items-center min-h-[75px] justify-between p-4 cursor-pointer hover:bg-gray-50 transition-colors">{t8}{t9}</label>;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== handleChangePoint || $[30] !== hasSelectedPoint || $[31] !== isSelected || $[32] !== needsDeliveryPoint || $[33] !== selectedDeliveryPoint) {
    t11 = isSelected && needsDeliveryPoint && hasSelectedPoint && <DeliveryPointDisplay deliveryPoint={selectedDeliveryPoint} onChangePoint={handleChangePoint} />;
    $[29] = handleChangePoint;
    $[30] = hasSelectedPoint;
    $[31] = isSelected;
    $[32] = needsDeliveryPoint;
    $[33] = selectedDeliveryPoint;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== hasSelectedPoint || $[36] !== isSelected || $[37] !== needsDeliveryPoint || $[38] !== option.name) {
    t12 = isSelected && needsDeliveryPoint && !hasSelectedPoint && <div className="flex justify-between items-center p-4 bg-amber-50 border-t border-amber-200"><Text text={"Wybierz punkt dostawy, aby kontynuowa\u0107"} fontSize={TextSize.S} weight={TextWeight.MEDIUM} /><Button text="Wybierz" variant={ButtonVariant.SECONDARY} size={ButtonSize.XS} onClick={() => {
        if (option.name === "InPost Paczkomat 24/7 dostawa D+1") {
          setIsInPostMapVisible(true);
        } else {
          if (option.name === "Odbi\xF3r w punkcie GLS") {
            setIsGLSMapVisible(true);
          }
        }
      }} /></div>;
    $[35] = hasSelectedPoint;
    $[36] = isSelected;
    $[37] = needsDeliveryPoint;
    $[38] = option.name;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== onDeliveryPointSelected || $[41] !== option.id || $[42] !== setSelectedOption) {
    t13 = point => {
      console.log("onPointSelected", point);
      setSelectedOption(option.id.toString(), "inpost", point.name);
      onDeliveryPointSelected(point);
      setIsInPostMapVisible(false);
    };
    $[40] = onDeliveryPointSelected;
    $[41] = option.id;
    $[42] = setSelectedOption;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setIsInPostMapVisible(false);
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== isInPostMapVisible || $[46] !== t13) {
    t15 = <InPostMap onPointSelected={t13} isVisible={isInPostMapVisible} onClose={t14} />;
    $[45] = isInPostMapVisible;
    $[46] = t13;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== onDeliveryPointSelected || $[49] !== option.id || $[50] !== setSelectedOption) {
    t16 = point_0 => {
      console.log("onPointSelected", point_0);
      setSelectedOption(option.id.toString(), "gls", point_0.id);
      onDeliveryPointSelected(point_0);
      setIsGLSMapVisible(false);
    };
    $[48] = onDeliveryPointSelected;
    $[49] = option.id;
    $[50] = setSelectedOption;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => setIsGLSMapVisible(false);
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== isGLSMapVisible || $[54] !== t16) {
    t18 = <GLSMap onPointSelected={t16} isVisible={isGLSMapVisible} onClose={t17} />;
    $[53] = isGLSMapVisible;
    $[54] = t16;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] !== t10 || $[57] !== t11 || $[58] !== t12 || $[59] !== t15 || $[60] !== t18) {
    t19 = <div className="border border-gray-200">{t10}{t11}{t12}{t15}{t18}</div>;
    $[56] = t10;
    $[57] = t11;
    $[58] = t12;
    $[59] = t15;
    $[60] = t18;
    $[61] = t19;
  } else {
    t19 = $[61];
  }
  return t19;
};
export const PaymentOption = t0 => {
  const $ = _c(20);
  const {
    option,
    selectedOption,
    setSelectedOption
  } = t0;
  let t1;
  if ($[0] !== option) {
    t1 = option.icon || getPaymentIcon(option);
    $[0] = option;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const icon = t1;
  const t2 = selectedOption === option.id;
  let t3;
  if ($[2] !== setSelectedOption) {
    t3 = e => setSelectedOption(e.target.value);
    $[2] = setSelectedOption;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== option.id || $[5] !== t2 || $[6] !== t3) {
    t4 = <input type="radio" name="payment" value={option.id} checked={t2} onChange={t3} className="w-4 h-4 accent-black border-gray-300 focus:ring-black " />;
    $[4] = option.id;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== icon || $[9] !== option.callToActionText) {
    t5 = icon && <div className="flex items-center space-x-4"><Image src={icon} alt={option.callToActionText} width={56} height={32} className="object-contain" /></div>;
    $[8] = icon;
    $[9] = option.callToActionText;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== option.callToActionText) {
    t6 = <Text text={option.callToActionText} weight={TextWeight.BOLD} fontSize={TextSize.S} />;
    $[11] = option.callToActionText;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className="flex items-center space-x-4">{t4}{t5}{t6}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== option.id || $[18] !== t7) {
    t8 = <label key={option.id} className="flex items-center min-h-[75px] justify-between p-4 border border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors">{t7}</label>;
    $[17] = option.id;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
const CheckoutOption = t0 => {
  const $ = _c(15);
  const {
    carriers,
    payments
  } = t0;
  const [selectedShippingOption, setSelectedShippingOption] = useState(null);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text text="Dostawa" weight={TextWeight.BOLD} fontSize={TextSize.S} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== carriers || $[2] !== selectedShippingOption) {
    let t3;
    if ($[4] !== selectedShippingOption) {
      t3 = carrier => <ShippingOption key={carrier.id} option={carrier} selectedOption={selectedShippingOption} setSelectedOption={setSelectedShippingOption} selectedDeliveryPoint={null} onDeliveryPointSelected={_temp} requiresDeliveryPointByName={_temp2} />;
      $[4] = selectedShippingOption;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = carriers.map(t3);
    $[1] = carriers;
    $[2] = selectedShippingOption;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Text text={"P\u0142atno\u015B\u0107"} weight={TextWeight.BOLD} fontSize={TextSize.S} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== payments || $[8] !== selectedPaymentOption) {
    let t5;
    if ($[10] !== selectedPaymentOption) {
      t5 = option => <PaymentOption key={option.id} option={option} selectedOption={selectedPaymentOption} setSelectedOption={setSelectedPaymentOption} />;
      $[10] = selectedPaymentOption;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = payments.map(t5);
    $[7] = payments;
    $[8] = selectedPaymentOption;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = <div className="max-w-4xl mx-auto p-6 bg-white"><div className="space-y-3">{t1}{t2}{t3}{t4}</div></div>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default CheckoutOption;
function _temp() {}
function _temp2() {
  return false;
}